import { render, staticRenderFns } from "./FormFieldSet.vue?vue&type=template&id=64baa95c"
import script from "./FormFieldSet.vue?vue&type=script&lang=js"
export * from "./FormFieldSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports